import { useContext, useEffect } from 'react';
import authContext from '../../context/auth/authContext.js'
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../presentation/redux/store/RootState';
import { BalanceActions } from '../../presentation/redux/actions/BalanceActions';
import { sessionLocalRepo } from '../../di/repo_module';
import { UIActions } from '../../presentation/redux/actions/UIActions';

export function Header() {

  const AuthContext = useContext(authContext);
  const { token, usuario, es_pin, uid, tipo_modelo } = AuthContext;

  const dispatch = useDispatch();
  const pos = useSelector((s: RootState) => s.balanceState.balance.pos);
  const balance = useSelector((s: RootState) => s.balanceState.balance.balance);
  const uiState = useSelector((s: RootState) => s.uiState);

  var date = new Date();
  date.toLocaleDateString("es-PE");

  useEffect(() => {
    dispatch(BalanceActions.updateBalance(token));
  }, [token, dispatch])

  const showhide = () => {
    if (uiState.isShowBalance) {
      dispatch(UIActions.hideBalance());
    } else {
      dispatch(UIActions.showBalance());
    }
  }

  return (
    <div className="row justify-content-center">
      <div className="col-md-8 d-flex flex-column" >
        <small className='pl-3 pt-3 telefono-pos'>Punto de venta: {pos} {es_pin && 'Pin:'} {uid} {tipo_modelo && `Modelo: ${tipo_modelo}`} </small>
        <h1 className="pl-3 mb-1 nombre">Hola, {usuario}</h1>
        <h5 className="pl-3 pb-3 fecha"> {date.toLocaleDateString('es-PE', { weekday: "long", year: "numeric", month: "long", day: "numeric" })}</h5>
      </div>
      <div className="col-md-4 align-content-end">
        <h5 className="pr-3 fecha text-right pt-3 mb-1">Tu Saldo</h5>
        <div className='wrapp-saldo'>
          <button type='button' className='btn show-saldo'
            onClick={showhide}>
            <i className={(uiState.isShowBalance) ? `fas fa-eye` : `fas fa-eye-slash`}></i>
          </button>
          <h1 className="pr-3 nombre text-right">{uiState.isShowBalance ? balance : '***'}</h1>
        </div>
        {
          sessionLocalRepo().getSession()?.purchaseCommission ?
            <h5 className="pr-3 fecha text-right pb-3 mb-1">Comisión a la compra: {sessionLocalRepo().getSession()?.purchaseCommission}</h5>
            : <div className="pd-3" />
        }
      </div>
    </div>);
}
